import { Component, OnInit } from '@angular/core';
import { WizardStep } from 'src/app/wizard/wizard.component';
import { ReferringPhysicianView } from '../../../model/referring-physician/referring-physician-view';
import { MedicalServiceWizardService } from 'src/app/services/wizard/medical-service/medical-service-wizard';
import { NotificationToastService } from 'src/app/services/notification-toast.service';

@Component({
  selector: 'app-medical-service-referring-physician-component',
  templateUrl: './medical-service-referring-physician.component.html',
  styleUrls: ['./medical-service-referring-physician.component.css']
})
export class MedicalServiceReferringPhysicianComponent implements OnInit, WizardStep {

  loading: boolean;
  completed: boolean;
  isInit: boolean;
  referringPhysicianView: ReferringPhysicianView;

  constructor(private medicalServiceWizardService: MedicalServiceWizardService
    , private notificationToastService: NotificationToastService) {
  }

  activate(): void {
  }

  save(): void {
  }

  get valid(): boolean {
    return this.completed;
  }


  async ngOnInit() {
    try {
      this.loading = true;
      this.referringPhysicianView = await this.medicalServiceWizardService.getReferringPhysicianView();
      this.completed = true;
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Médico derivante');
    } finally {
      this.loading = false;
    }
  }
}
